import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Typography } from 'antd';

const BulletItem = (props) => {
  const { children } = props;

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 8,
      }}
    >
      <span
        style={{
          color: 'white',
          paddingLeft: 10,
          fontSize: 20,
          lineHeight: '1.2',
        }}
      >
        •
      </span>
      <Typography.Text
        style={{
          color: 'white',
          fontSize: 16,
          fontWeight: 400,
        }}
      >
        {children}
      </Typography.Text>
    </div>
  );
};

BulletItem.propTypes = {
  children: PropTypes.node,
};

BulletItem.defaultProps = {
  children: null,
};

export default memo(BulletItem);
